// removed by extract-text-webpack-plugin
module.exports = {"page-header":"page-header--3ETd7q","menu-ctrl":"menu-ctrl--2BlDcr","module-user":"module-user--1Wo8Tn"};